import BreadCrumbs from '../../BreadCrumbs';
import SubHeader from '../common/SubHeader';

export function JobSearchClusterHeader({ headerTitle, ...data }) {
  const { breadCrumbs } = data;

  return (
    <>
      <div className="sub-header-container">
        <SubHeader {...data} />
      </div>
      <div className="container">
        <div className="d-none d-md-flex mt-20">
          {breadCrumbs && <BreadCrumbs breadCrumbs={breadCrumbs.slice(0, 3)} />}
        </div>
        {!!headerTitle && (
          <div className="w-635">
            <h1 className="brandonH2 mt-48 mb-48">{headerTitle}</h1>
          </div>
        )}
      </div>
    </>
  );
}
